var AssetCategory;
(function (AssetCategory) {
    AssetCategory["Vehicle"] = "VEHICLE";
    AssetCategory["Equipment"] = "EQUIPMENT";
    AssetCategory["Person"] = "PERSON";
})(AssetCategory || (AssetCategory = {}));
export default AssetCategory;
//# sourceMappingURL=asset-category.js.map